export const fa = {
  brand: 'دنس‌منس',
  brandLatin: 'Dance Mance',
  'brand.institute': 'پرتال آموزشگاه',
  loading: 'در حال بارگذاری',
  userFallback: 'کاربر',
  cancel: 'انصراف',
  close: 'بستن',
  done: 'تمام',
  save: 'ذخیره',
  create: 'ایجاد',
  open: 'باز کردن',
  send: 'ارسال',
  download: 'دانلود',
  minutes: '{n} دقیقه',
  leftCount: '{n} باقی‌مانده',
  taught: 'آموزش‌داده‌شده: {topics}',

  'nav.dashboard': 'داشبورد',
  'nav.classes': 'کلاس‌ها',
  'nav.mySchedule': 'برنامه من',
  'nav.schedule': 'برنامه',
  'nav.events': 'رویدادها',
  'nav.billing': 'مالی',
  'nav.cashbook': 'صندوق',
  'nav.students': 'هنرجویان',
  'nav.people': 'اشخاص',
  'nav.enrollments': 'ثبت‌نام‌ها',
  'nav.notices': 'اطلاعیه‌ها',
  'nav.profile': 'پروفایل',
  'nav.settings': 'تنظیمات',
  'nav.pay': 'حقوق',
  'nav.analytics': 'تحلیل‌ها',
  'nav.leave': 'مرخصی',
  'nav.attendance': 'حضور و غیاب',
  'nav.activity': 'فعالیت‌ها',
  'nav.main': 'منوی اصلی',
  'nav.mobile': 'منوی موبایل',
  'nav.openMenu': 'باز کردن منو',
  'nav.closeMenu': 'بستن منو',
  'nav.signOut': 'خروج',
  'nav.group.overview': 'نمای کلی',
  'nav.group.manage': 'مدیریت',
  'nav.group.finance': 'مالی',
  'nav.group.account': 'حساب',
  'nav.account': 'حساب من',
  'tabs.label': 'بخش‌ها',

  'role.admin': 'مدیر',
  'role.owner': 'مالک',
  'role.coach': 'مربی',
  'role.student': 'هنرجو',
  'role.operator': 'پرسنل',

  'status.active': 'فعال',
  'status.inactive': 'غیرفعال',
  'status.banned': 'مسدود',
  'status.scheduled': 'برنامه‌ریزی‌شده',
  'status.cancelled': 'لغوشده',
  'status.completed': 'تمام‌شده',
  'status.pending': 'در انتظار',
  'status.due': 'بدهکار',
  'status.paid': 'پرداخت‌شده',
  'status.overdue': 'سررسید گذشته',
  'status.present': 'حاضر',
  'status.absent': 'غایب',
  'status.on_leave': 'مرخصی',
  'status.unmarked': 'ثبت‌نشده',
  'status.attended': 'حاضر',
  'status.registered': 'ثبت‌نام',
  'status.sent': 'ارسال‌شده',
  'status.failed': 'ناموفق',
  'status.draft': 'پیش‌نویس',
  'status.income': 'درآمد',
  'status.expense': 'هزینه',
  'status.approved': 'تأیید شده',
  'status.denied': 'رد شده',

  'dance.salsa': 'سالسا',
  'dance.bachata': 'باچاتا',
  'dance.tango': 'تانگو',
  'dance.yoga': 'یوگا',
  'dance.other': 'سایر',

  'eventType.practica': 'پراکتیکا',
  'eventType.social_dance': 'رقص اجتماعی',
  'eventType.workshop': 'ورکشاپ',
  'eventType.practice': 'تمرین',
  'eventType.other': 'سایر',

  'level.beginner': 'مقدماتی',
  'level.intermediate': 'متوسط',
  'level.advanced': 'پیشرفته',
  'level.open': 'آزاد',

  'kind.session': 'جلسه',
  'kind.event': 'رویداد',
  'kind.progress': 'پیشرفت',

  'demo.short': 'پیش‌نمایش دمو — هر رمزی کار می‌کند.',
  'demo.full': 'پیش‌نمایش دمو — با {owner}، {admin}، {coach} یا {student} وارد شوید (هر رمزی).',
  'demo.quick': 'ورود سریع دمو',
  'demo.ownerRole': 'مالک سیستم',
  'demo.adminRole': 'دسترسی کامل',
  'demo.coachRole': 'جلسات و حضور',
  'demo.studentRole': 'کلاس و مالی',
  'demo.operatorRole': 'صندوق فروش',
  'demo.passwordHint': 'در حالت دمو هر رمزی قبول است',

  'auth.welcomeBack': 'خوش آمدید',
  'auth.whoAreYou': 'امروز چه نقشی دارید؟',
  'auth.signInSubtitle': 'ورود به حساب دنس‌منس',
  'auth.chooseRole': 'نقش خود را انتخاب کنید تا پنل شخصی‌تان باز شود',
  'auth.enterPanel': 'ورود به پنل',
  'auth.orEmail': 'یا با ایمیل وارد شوید',
  'auth.signIn': 'ورود',
  'auth.signInFailed': 'ورود ناموفق بود. دوباره تلاش کنید.',
  'auth.noAccount': 'حساب ندارید؟',
  'auth.signUpLink': 'ثبت‌نام',
  'auth.createAccount': 'ساخت حساب',
  'auth.signUpSubtitle': 'به استودیوی دنس‌منس بپیوندید',
  'auth.fullName': 'نام کامل',
  'auth.email': 'ایمیل',
  'auth.emailOrPhone': 'ایمیل یا شماره موبایل',
  'auth.emailOrPhoneHint': 'می‌توانید با نشانی ایمیل یا شماره موبایل وارد شوید',
  'auth.phone': 'تلفن همراه',
  'auth.phoneOptional': 'شماره موبایل (اختیاری)',
  'auth.phoneOptionalHint': 'برای ورود سریع و دریافت اطلاعیه‌ها',
  'auth.phoneHint': 'برای ورود پیامکی و اطلاعیه‌ها',
  'auth.password': 'رمز عبور',
  'auth.passwordHint': 'حداقل ۸ نویسه',
  'auth.signUpFailed': 'ثبت‌نام ناموفق بود. دوباره تلاش کنید.',
  'auth.hasAccount': 'حساب دارید؟',
  'auth.tagline': 'پنل دنس‌منس',
  'auth.copyright': '© 1405 تمامی حقوق برای شرکت فراز بینش مانا محفوظ است.',
  'auth.methodEmail': 'ایمیل یا موبایل',
  'auth.methodPhone': 'پیامک یکبارمصرف',
  'auth.tabEmailMobile': 'ایمیل یا موبایل',
  'auth.tabSms': 'ورود با پیامک (SMS)',
  'auth.forgotPassword': 'فراموشی رمز عبور؟',
  'auth.forgotPasswordTitle': 'بازیابی رمز عبور',
  'auth.forgotPasswordSubtitle': 'برای بازیابی رمز، ایمیل یا شماره موبایل خود را وارد کنید.',
  'auth.forgotMethodPhone': 'پیامک به موبایل',
  'auth.forgotMethodEmail': 'لینک به ایمیل',
  'auth.sendResetCode': 'ارسال کد بازیابی',
  'auth.sendResetLink': 'ارسال لینک بازیابی به ایمیل',
  'auth.newPassword': 'رمز عبور جدید',
  'auth.confirmNewPassword': 'تکرار رمز عبور جدید',
  'auth.resetPasswordSubmit': 'ثبت رمز عبور جدید و ورود',
  'auth.passwordResetSuccess': 'رمز عبور با موفقیت تغییر کرد. اکنون می‌توانید وارد شوید.',
  'auth.emailResetSent': 'لینک بازیابی رمز عبور با موفقیت به ایمیل شما ارسال شد.',
  'auth.backToSignIn': 'بازگشت به صفحه ورود',
  'auth.quickSmsHint': 'رمز عبور را به یاد ندارید؟',
  'auth.quickSmsAction': 'ورود مستقیم بدون نیاز به رمز با پیامک یکبارمصرف',
  'auth.passwordsDontMatch': 'رمز عبور جدید با تکرار آن یکسان نیست.',
  'auth.passwordTooShort': 'رمز عبور باید حداقل ۶ کاراکتر باشد.',
  'auth.otpSend': 'ارسال کد',
  'auth.otpResend': 'ارسال دوباره',
  'auth.otpCode': 'کد پیامک',
  'auth.otpHint': 'کد پنج‌رقمی پیامک‌شده را وارد کنید',
  'auth.otpSent': 'کد به {phone} ارسال شد',
  'auth.otpInvalidPhone': 'شماره موبایل معتبر نیست',
  'auth.signOut': 'خروج',
  'auth.debugCode': 'کد آزمایشی: {code}',

  'verifyContact.title': 'تأیید تماس',
  'verifyContact.subtitle': 'برای ادامه، ایمیل یا موبایل خود را تأیید کنید.',
  'verifyContact.emailTab': 'ایمیل',
  'verifyContact.phoneTab': 'موبایل',
  'verifyContact.emailHint': 'کد به {email} ارسال می‌شود.',
  'verifyContact.phoneHint': 'کد به {phone} پیامک می‌شود.',
  'verifyContact.noPhone': 'شماره موبایل در پروفایل ثبت نشده. از تب ایمیل استفاده کنید یا از مدیر بخواهید شماره را اضافه کند.',
  'verifyContact.codeLabel': 'کد تأیید',
  'verifyContact.sendCode': 'ارسال کد',
  'verifyContact.confirm': 'تأیید',
  'verifyContact.failed': 'تأیید ناموفق بود. دوباره تلاش کنید.',
  'auth.changePhone': 'تغییر شماره',
  'auth.phoneSignInSubtitle': 'ورود با شماره موبایلی که خودتان ثبت کرده‌اید',
  'auth.phoneSignUpSubtitle': 'ثبت‌نام با شماره موبایل و تأیید پیامکی',
  'auth.debugOtp': 'حالت توسعه: کد {code}',

  'demo.ownerDesc': 'همه‌چیز به‌علاوه مدیریت مدیران — انتصاب و حذف ادمین',
  'demo.adminDesc': 'کنترل کامل آموزشگاه — کلاس‌ها، ثبت‌نام، مالی و مربیان',
  'demo.coachDesc': 'برنامه، جلسات و جزئیات حقوق',
  'demo.studentDesc': 'کلاس‌ها، دوره جلسات، مرخصی و فاکتورها',
  'demo.operatorDesc': 'فروش، هزینه، سهم کسب‌وکار و سود',

  'dashboard.greetingMorning': 'صبح بخیر، {name}',
  'dashboard.greetingAfternoon': 'ظهر بخیر، {name}',
  'dashboard.greetingEvening': 'عصر بخیر، {name}',
  'dashboard.subtitle': 'وضعیت امروز استودیو',
  'dashboard.subtitleAdmin': 'الان چه چیزی نیاز به رسیدگی دارد؟',
  'dashboard.subtitleCoach': 'الان چه چیزی تدریس می‌کنید و چه کسانی هستند؟',
  'dashboard.subtitleStudent': 'جلسه بعد شما چیست و وضعیتتان چطور است؟',
  'dashboard.subtitleOperator': 'امروز چه فروخته‌اید و سهم چگونه است؟',
  'dashboard.heroEyebrow': 'وضعیت امروز',
  'dashboard.heroTitle': 'آموزشگاه {brand}',
  'dashboard.heroMeta': '{sessions} جلسه · {events} رویداد · {payments} پرداخت سررسید',
  'dashboard.todaySessions': 'جلسات امروز',
  'dashboard.todayEvents': 'رویدادهای امروز',
  'dashboard.attendanceDone': 'حضور تکمیل‌شده',
  'dashboard.paymentsDue': 'پرداخت‌های سررسید',
  'dashboard.attention': 'نیاز به رسیدگی',
  'dashboard.attentionEmpty': 'الان موردی برای رسیدگی نیست.',
  'dashboard.act': 'اقدام',
  'dashboard.todaySchedule': 'برنامه امروز',
  'dashboard.viewSchedule': 'دیدن برنامه',
  'dashboard.sessionsRemaining': 'جلسات باقی‌مانده',
  'dashboard.perEnrollment': 'در هر ثبت‌نام',
  'dashboard.activeClasses': 'کلاس‌های فعال',
  'dashboard.manage': 'مدیریت',
  'dashboard.kpi.sessionsSub': 'در برنامه امروز',
  'dashboard.kpi.eventsSub': 'رویدادهای امروز',
  'dashboard.kpi.attendanceSub': 'ثبت حضور امروز',
  'dashboard.kpi.paymentsSub': 'هنرجویان معوق',

  'analytics.title': 'تحلیل‌ها',
  'analytics.subtitle': 'اعداد بزرگ، رنگ‌های واضح — بدون نمودار گیج‌کننده.',
  'analytics.week': 'این هفته',
  'analytics.month': 'این ماه',
  'analytics.attendance': 'نرخ حضور',
  'analytics.seats': 'صندلی‌های پر',
  'analytics.classesHeld': 'کلاس‌های برگزارشده',
  'analytics.invoicesPaid': 'فاکتورهای پرداخت‌شده',
  'analytics.popularity': 'محبوبیت کلاس',
  'analytics.workload': 'بار کاری مربی',
  'analytics.tip': '{name} بیشترین جلسه را دارد ({count}). در صورت نزدیک بودن به ظرفیت، توزیع مجدد را در نظر بگیرید.',
  'analytics.empty': 'داده‌ای برای این بازه نیست.',
  'analytics.of': '{val} از {max}',

  'exception.attendance': '{count} جلسه بدون ثبت کامل حضور',
  'exception.replacement': '{count} جایگزینی مربی',
  'exception.payment': '{count} پرداخت سررسید',
  'exception.cancelled': '{count} جلسه لغوشده',
  'exception.event': '{count} رویداد تغییرکرده',
  'exception.split': 'سهم درآمد تغییر کرده است',
  'attendance.unmarked': 'ثبت‌نشده',
  'attendance.partial': 'ناقص',
  'attendance.complete': 'کامل',
  'session.scheduledCoach': 'مربی برنامه‌ریزی‌شده',
  'session.actualCoach': 'مربی این جلسه',
  'session.classCoach': 'مربی کلاس',
  'session.previous': 'جلسه قبل',
  'session.todayTopic': 'امروز',
  'session.noTopic': 'موضوعی ثبت نشده',
  'session.unmarked': '{count} نفر ثبت‌نشده',
  'session.replaceCoach': 'مربی جایگزین این جلسه',
  'scope.title': 'نمای کلاس‌ها',
  'scope.today': 'امروز',
  'scope.week': 'هفته',
  'scope.month': 'ماه',
  'scope.empty': 'در این بازه کلاسی در دسترس شما نیست.',
  'scope.noSessions': 'جلسه‌ای در این بازه نیست.',
  'scope.classMeta': '{sessions} جلسه · {unmarked} ثبت‌نشده',
  'scope.events': 'رویدادهای این بازه',
  'scope.classesTab': 'کلاس‌ها',
  'scope.eventsTab': 'رویدادها',
  'scope.emptyEvents': 'رویدادی در این روز نیست.',
  'scope.held': 'برگزار شده',
  'scope.live': 'در حال برگزاری',
  'coach.nextSession': 'جلسه بعد',
  'coach.noSession': 'امروز جلسه‌ای برای شما نیست.',
  'coach.upcoming': 'جلسات بعدی امروز',
  'student.nextClass': 'کلاس بعد',
  'student.noNext': 'کلاس آینده‌ای در برنامه نیست.',
  'student.payment': 'وضعیت پرداخت',
  'student.paymentOverdue': 'پرداخت شما سررسید گذشته است.',
  'student.paymentDue': 'الان مبلغی برای پرداخت دارید.',
  'student.paymentClear': 'الان بدهی ندارید.',
  'student.openBilling': 'دیدن جزئیات مالی',
  'student.myClasses': 'کلاس‌های من',
  'student.nextSession': 'جلسه بعد',
  'student.missed': 'چه چیزی را از دست دادم',
  'student.welcomeEyebrow': 'داشبورد شما',
  'student.welcomeHi': 'سلام',
  'student.enrolledIn': 'ثبت‌نام در {className}',
  'student.since': 'از {date}',
  'student.packTitle': 'دوره جلسات من',
  'student.packHint': 'بعد از هر {n} جلسه مصرف‌شده، فاکتور صادر می‌شود',
  'student.packInvoiceDue': 'فاکتور سررسید شده — برای ادامه لطفاً پرداخت کنید 🙏',
  'student.packRemaining': '{n} جلسه تا فاکتور بعدی',
  'student.factCoach': 'مربی',
  'student.sessionsLeft': 'جلسه باقی',
  'operator.grossSales': 'فروش ناخالص امروز',
  'operator.transactions': 'تعداد تراکنش',
  'operator.currentSplit': 'سهم فعلی',
  'operator.splitLine': 'پرسنل {operator}٪ · آموزشگاه {institute}٪',
  'operator.effectiveFrom': 'اعتبار از',
  'operator.operatorShare': 'سهم پرسنل',
  'operator.instituteShare': 'سهم آموزشگاه',
  'operator.settlement.today': 'تسویه امروز',
  'operator.settlement.week': 'تسویه هفته',
  'operator.settlement.month': 'تسویه ماه',
  'operator.shareShort': 'پرسنل {operator} · آموزشگاه {institute}',
  'operator.openCashbook': 'ثبت فروش',
  'operator.revenueSplit': 'سهم درآمد بار',
  'operator.operatorPercent': 'سهم پرسنل (٪)',
  'operator.institutePercent': 'سهم آموزشگاه (٪)',
  'operator.saveSplit': 'اعمال سهم جدید',
  'operator.splitInvalid': 'جمع دو سهم باید دقیقاً ۱۰۰ باشد. تاریخچه بازنویسی نمی‌شود.',
  'dashboard.people': 'اشخاص',
  'dashboard.peopleHint': 'اطلاعات پایه هنرجو و مربی، تلفن و یادداشت.',
  'dashboard.openDirectory': 'باز کردن فهرست',
  'dashboard.classesFiles': 'کلاس‌ها و فایل‌ها',
  'dashboard.classesFilesHint': 'فهرست نفرات، فایل آموزشی و یادداشت پیشرفت روی هر کلاس است.',
  'dashboard.openClasses': 'باز کردن کلاس‌ها',
  'dashboard.notices': 'اطلاعیه‌ها',
  'dashboard.noticesHint': 'ارسال پیامک (SMS.ir) و ایمیل به یک کلاس، رویداد یا همه هنرجویان.',
  'dashboard.sendNotice': 'ارسال اطلاعیه',
  'dashboard.timeline': 'خط زمانی یادگیری شما',
  'dashboard.timelineMeta': '{present} حضور · {sessions} جلسه محاسبه‌شونده · {events} رویداد',
  'dashboard.sessionsToday': 'جلسات امروز',
  'dashboard.sessionsTodayBody': '{count} جلسه در برنامه است. برای حضور به برنامه بروید.',
  'dashboard.openSchedule': 'باز کردن برنامه',

  'classes.title': 'کلاس‌ها',
  'classes.subtitle': 'نقشه عملیاتی استودیو — چه چیزی، چه زمانی، و توسط چه کسی',
  'classes.new': 'کلاس جدید',
  'classes.loadFailed': 'بارگذاری کلاس‌ها ناموفق بود',
  'classes.empty': 'هنوز کلاسی نیست',
  'classes.emptyAdmin': 'اولین کلاس را بسازید تا جلسات زمان‌بندی شود.',
  'classes.emptyStudent': 'کلاس‌ها پس از ثبت‌نام اینجا دیده می‌شوند.',
  'classes.enroll': 'ثبت‌نام هنرجو',
  'classes.enrollTitle': 'ثبت‌نام — {name}',
  'classes.enrollSuccess': 'هنرجو با موفقیت ثبت شد.',
  'classes.enrollFailed': 'ثبت‌نام ناموفق بود',
  'classes.student': 'هنرجو',
  'classes.sessionsPerUnit': 'جلسه در هر واحد پرداخت',
  'classes.sessionsPerUnitHint': 'پیش‌فرض: ۴ جلسه محاسبه‌شونده تا سررسید پرداخت',
  'classes.scheduleSession': 'زمان‌بندی جلسه',
  'classes.scheduleTitle': 'زمان‌بندی — {name}',
  'classes.dateTime': 'تاریخ و ساعت',
  'date.placeholder': 'تاریخ را انتخاب کنید',
  'date.year': 'سال',
  'date.month': 'ماه',
  'date.hour': 'ساعت',
  'date.minute': 'دقیقه',
  'classes.scheduleFailed': 'زمان‌بندی جلسه ناموفق بود',
  'classes.schedule': 'زمان‌بندی',
  'classes.roster': 'فهرست نفرات',
  'classes.noStudents': 'هنرجویی ثبت‌نام نشده.',
  'classes.files': 'فایل‌ها',
  'classes.noFiles': 'هنوز فایلی نیست.',
  'classes.progressNote': 'یادداشت پیشرفت',
  'classes.note': 'یادداشت',
  'classes.saveProgress': 'ذخیره پیشرفت',
  'classes.className': 'نام کلاس',
  'classes.danceType': 'نوع رقص / ورزش',
  'classes.description': 'توضیح',
  'classes.duration': 'مدت پیش‌فرض (دقیقه)',
  'classes.coach': 'مربی',
  'classes.coaches': 'مربیان',
  'classes.assistants': 'کمک‌مربیان',
  'classes.coachRequired': 'حداقل یک مربی لازم است',
  'classes.location': 'مکان',
  'multiselect.placeholder': 'انتخاب کنید',
  'multiselect.empty': 'کسی در فهرست نیست',
  'multiselect.remove': 'حذف {name}',
  'classes.searchStudent': 'جستجوی شماره تلفن، نام یا ایمیل',
  'classes.createStudent': 'ساخت هنرجوی جدید',
  'classes.createStudentTitle': 'ثبت هنرجوی جدید',
  'classes.searchInstead': 'بازگشت به جستجو',
  'classes.pickStudent': 'یک هنرجو را از فهرست انتخاب کنید',
  'classes.noMatch': 'نتیجه‌ای پیدا نشد. هنرجوی جدید بسازید.',
  'classes.searching': 'در حال جستجو...',
  'classes.typeToSearch': 'حداقل دو نویسه وارد کنید',
  'classes.suggestions': 'پیشنهادها',
  'classes.toggleSuggestions': 'نمایش پیشنهادها',
  'classes.removeStudent': 'حذف از کلاس',
  'classes.removeConfirm': 'این هنرجو از کلاس حذف شود؟',
  'classes.addStudent': 'افزودن هنرجو',
  'classes.createFailed': 'ساخت کلاس ناموفق بود',
  'classes.registrationOpen': 'باز برای ثبت‌نام جدید',
  'classes.telegramGroup': 'لینک گروه تلگرام کلاس',
  'classes.telegramGroupHint': 'آیدی، @نام‌کاربری یا لینک t.me گروه',
  'classes.openTitle': 'کلاس‌های باز برای ثبت‌نام',
  'classes.openSubtitle': 'کلاس‌های تازه‌باز را ببینید و برای ثبت‌نام با ادمین در تلگرام صحبت کنید',
  'classes.openEmpty': 'الان کلاس باز برای ثبت‌نام نیست',
  'classes.openCta': 'پیام به ادمین',
  'classes.enrolledAlready': 'شما در این کلاس هستید',
  'classes.openTab': 'ثبت‌نام',
  'classes.scheduleSection': 'زمان‌بندی و برنامه برگزاری',
  'classes.scheduleDay': 'روز برگزاری',
  'classes.scheduleTime': 'ساعت برگزاری',
  'classes.scheduleFrequency': 'تکرار برگزاری',
  'classes.frequency.weekly': 'هفتگی',
  'classes.frequency.biweekly': 'دو هفته یک‌بار',
  'classes.frequency.daily': 'روزانه',
  'classes.frequency.monthly': 'ماهانه‌',
  'classes.compensationSection': 'حق‌الزحمه و تسهیم درآمد مربیان',
  'classes.compensationHint': 'تعیین دستمزد مربیان برای این کلاس به‌صورت سهم درصدی از شهریه یا مبلغ ثابت برای هر جلسه.',
  'classes.compensationType': 'نوع تسویه',
  'classes.compensationPercentage': 'درصدی از شهریه (%)',
  'classes.compensationFixed': 'مبلغ ثابت هر جلسه (تومان)',
  'classes.compensationCoachRate': 'مبلغ یا درصد سهم',
  'classes.compensationTotalError': 'مجموع سهم درصدی مربیان نمی‌تواند بیش از ۱۰۰٪ باشد.',
  'classes.pricingSection': 'شهریه و دوره پرداخت هنرجویان',
  'classes.pricingHint': 'شهریه کل دوره بر تعداد جلسات تقسیم شده و به عنوان واحد پرداخت فاکتور ثبت می‌شود.',
  'classes.totalCoursePrice': 'شهریه کل دوره (تومان)',
  'classes.sessionsInCourse': 'تعداد جلسات هر دوره',
  'classes.pricePerSession': 'شهریه هر جلسه (تومان)',
  'classes.perSessionEquivalent': 'معادل {amount} تومان برای هر جلسه',
  'billing.classShares': 'تسهیم درآمد کلاس‌ها',
  'billing.classSharesSubtitle': 'محاسبه سهم هر مربی و آموزشگاه بر اساس مدل قرارداد کلاس‌ها',
  'billing.classCoachShares': 'سهم مربیان',
  'billing.coachesCost': 'هزینه مربیان',
  'billing.instituteShare': 'سهم آموزشگاه',

  'telegram.group': 'گروه تلگرام کلاس',
  'telegram.admin': 'تلگرام ثبت‌نام ادمین',
  'telegram.settingsTitle': 'ارتباط تلگرام',
  'telegram.settingsSubtitle': 'آیدی یا لینک چت ادمین برای درخواست ثبت‌نام کلاس',
  'telegram.adminField': 'آیدی / لینک تلگرام ثبت‌نام',
  'telegram.adminHint': '@username یا لینک t.me — هنرجویان روی کارت کلاس می‌بینند',
  'telegram.saved': 'مخاطب تلگرام ذخیره شد.',
  'telegram.saveFailed': 'ذخیره مخاطب تلگرام ناموفق بود',

  'locations.title': 'مکان‌های شعبه',
  'locations.subtitle': 'سالن‌ها و فضاهایی که کلاس‌ها، جلسات و رویدادها در آن برگزار می‌شوند. برای همه نقش‌ها دیده می‌شود.',
  'locations.add': 'افزودن مکان',
  'locations.name': 'نام مکان',
  'locations.address': 'آدرس',
  'locations.latitude': 'عرض جغرافیایی',
  'locations.longitude': 'طول جغرافیایی',
  'locations.coordsHint': 'اختیاری — برای نقشه، هر دو مختصات را وارد کنید',
  'locations.openMap': 'باز کردن در نقشه',
  'locations.openMapWeb': 'نقشه در مرورگر',
  'locations.useGps': 'موقعیت فعلی (GPS)',
  'locations.gpsFailed': 'دریافت موقعیت ممکن نشد.',
  'locations.gpsDenied': 'دسترسی به موقعیت رد شد. در تنظیمات مرورگر اجازه دهید.',
  'locations.gpsTimeout': 'دریافت موقعیت بیش از حد طول کشید. دوباره تلاش کنید.',

  'settings.tabContact': 'تماس و تلگرام',
  'settings.tabLocations': 'مکان‌ها',
  'settings.tabLeave': 'مرخصی',
  'locations.coords': '{lat}، {lng}',
  'locations.coordsInvalid': 'عرض و طول جغرافیایی باید با هم وارد شوند',
  'locations.empty': 'هنوز مکانی ثبت نشده',
  'locations.delete': 'حذف',
  'locations.edit': 'ویرایش',
  'locations.inUse': 'این مکان در کلاس، جلسه یا رویداد استفاده می‌شود و قابل حذف نیست',
  'locations.exists': 'مکانی با این نام وجود دارد',
  'locations.none': 'بدون مکان',
  'locations.inherit': 'همان مکان کلاس',
  'locations.saveFailed': 'ذخیره مکان ناموفق بود',
  'locations.saved': 'مکان‌ها به‌روز شد.',

  'share.label': 'اشتراک‌گذاری',
  'share.telegram': 'تلگرام',
  'share.whatsapp': 'واتساپ',
  'share.copy': 'کپی لینک',
  'share.copied': 'لینک کپی شد',

  'theme.label': 'پوسته',
  'theme.system': 'سیستم',
  'theme.light': 'روشن',
  'theme.dark': 'تیره',

  'cal.subtitle': 'نقشه عملیاتی استودیو — چه چیزی در جریان است؟',
  'cal.subtitleCoach': 'این هفته مسئول چه چیزی هستید؟',
  'cal.subtitleStudent': 'کلاس‌ها و جلسات شما',
  'cal.subtitleOperator': 'نقشه عملیاتی استودیو — فقط مشاهده',
  'cal.today': 'امروز',
  'cal.prev': 'بازه قبل',
  'cal.next': 'بازه بعد',
  'cal.week': 'هفته',
  'cal.month': 'ماه',
  'cal.day': 'روز',
  'cal.layout': 'نوع نمایش',
  'cal.layout.calendar': 'تقویم',
  'cal.layout.timeline': 'خط زمانی',
  'cal.closePanel': 'بستن جزئیات جلسه',
  'cal.search': 'جستجوی کلاس...',
  'cal.allCoaches': 'همه مربیان',
  'cal.allTypes': 'همه انواع',
  'cal.allStatus': 'همه وضعیت‌ها',
  'cal.allLocations': 'همه مکان‌ها',
  'cal.status.attention': 'نیاز به رسیدگی',
  'cal.status.replacement': 'جایگزینی مربی',
  'cal.density': 'تراکم',
  'cal.compact': 'فشرده',
  'cal.comfortable': 'راحت',
  'cal.students': '{n} هنرجو',
  'cal.presentOf': '{present} از {total} حاضر',
  'cal.empty': 'در این بازه موردی نیست.',
  'cal.loadFailed': 'بارگذاری برنامه ناموفق بود',
  'cal.legend.session': 'جلسه',
  'cal.legend.event': 'رویداد',
  'cal.legend.attention': 'حضور ناقص',
  'cal.legend.replacement': 'جایگزین',
  'cal.legend.cancelled': 'لغوشده',
  'cal.event': 'رویداد',
  'cal.time': 'ساعت',
  'cal.weekGrid': 'نمای هفته',
  'cal.weekScrollHint': 'روز را از نوار بالا بزنید، یا جدول هفته را افقی بکشید — ستون ساعت ثابت می‌ماند',
  'cal.openClass': 'جزئیات کلاس',
  'cal.replacement': 'جایگزین',
  'cal.eventsRow': 'رویدادها',
  'class.back': 'کلاس‌ها',
  'class.edit': 'ویرایش کلاس',
  'class.overview': 'نمای کلی',
  'class.sessions': 'جلسات',
  'class.students': 'هنرجویان',
  'class.nextSession': 'جلسه بعد',
  'class.openSession': 'باز کردن جلسه',
  'class.healthUpcoming': 'پیش رو',
  'class.healthAttendance': 'حضور',
  'class.healthStudents': 'هنرجویان',
  'class.attendanceDone': '{done} از {total} تکمیل‌شده',
  'class.attendanceTab': 'حضور و غیاب',
  'class.attendanceHint': 'جلسه را انتخاب کنید و وضعیت هر هنرجو را ثبت کنید. حاضر یا غایب یک جلسه از دوره مصرف می‌کند؛ مرخصی فقط با درخواست تأییدشده.',
  'class.sessionHistory': 'تاریخچه جلسات',
  'class.topic': 'موضوع',
  'class.viewSession': 'دیدن جلسه',
  'class.noUpcoming': 'جلسه آینده‌ای نیست.',
  'class.noSessions': 'هنوز جلسه‌ای ثبت نشده.',
  'class.present': '{n} حاضر',
  'class.absent': '{n} غایب',
  'class.leave': '{n} مرخصی',
  'class.enrolled': '{n} ثبت‌نام',
  'class.saveFailed': 'ذخیره کلاس ناموفق بود',
  'session.takeAttendance': 'ثبت حضور',
  'session.hideAttendance': 'بستن حضور',
  'session.notes': 'یادداشت جلسه',
  'session.taughtPrompt': 'چه چیزی تدریس کردید؟',
  'session.previousTopic': 'قبلی',
  'session.progress': 'وضعیت هنرجو در این جلسه',
  'session.cancelled': 'این جلسه لغو شده است.',
  'session.statusTab': 'وضعیت جلسه',
  'session.statusStaffingHint': 'مربی جایگزین یا کمک‌مربی این جلسه را قبل از لغو یا جابه‌جایی تنظیم کنید.',
  'session.statusAssistant': 'کمک‌مربی این جلسه',
  'session.statusNoAssistant': '— بدون کمک‌مربی —',
  'session.statusCancelSection': 'لغو جلسه',
  'session.statusCancelReason': 'دلیل لغو (اختیاری)',
  'session.statusRescheduleDefault': 'جلسهٔ جایگزین در تقویم (پیش‌فرض: هفتهٔ بعد، همان ساعت)',
  'session.statusOffsetDays': 'فاصله از این جلسه (روز)',
  'session.statusOffsetWeek': '{n} هفته بعد',
  'session.statusReschedulePreview': 'جلسهٔ جایگزین: {date} · {time}',
  'session.statusRescheduledHint': 'جلسه لغو شد و جلسهٔ جایگزین در تقویم ثبت شد.',
  'session.statusCancelledOnly': 'جلسه لغو شد (بدون جلسهٔ جایگزین).',
  'session.statusCancelFailed': 'لغو جلسه ناموفق بود',
  'session.statusSaveFailed': 'ذخیرهٔ وضعیت ناموفق بود',
  'session.statusAddSection': 'افزودن جلسه به چرخهٔ کلاس',
  'session.statusAddHint': 'برای ادامهٔ بی‌پایان برنامه، یک جلسهٔ جدید بدون لغو این جلسه اضافه کنید.',
  'session.statusAddPreview': 'زمان پیشنهادی: {date}',
  'session.statusAddButton': 'افزودن جلسه',
  'session.statusAddedSession': 'جلسهٔ جدید ثبت شد.',
  'session.statusAddFailed': 'افزودن جلسه ناموفق بود',
  'session.statusOpenNewSession': 'باز کردن جلسهٔ جدید',
  'session.statusCancellation': 'جزئیات لغو',
  'session.statusNoReason': 'دلیلی ثبت نشده',
  'session.loadFailed': 'بارگذاری جلسه ناموفق بود',
  'session.open': 'باز کردن جلسه',
  'durationHours': '{n} ساعت',

  'schedule.title': 'برنامه',
  'schedule.subtitle': 'جلسات کلاس و رویدادها — امروز، هفته یا ماه',
  'schedule.manageClasses': 'مدیریت کلاس‌ها',
  'schedule.loadFailed': 'بارگذاری برنامه ناموفق بود',
  'schedule.empty': 'امروز جلسه‌ای نیست',
  'schedule.emptyHint': 'جلسات و رویدادهای امروز اینجا دیده می‌شوند.',
  'schedule.classSession': 'جلسه کلاس',
  'schedule.takeAttendance': 'ثبت حضور',
  'schedule.cancelSession': 'لغو جلسه',
  'schedule.cancelPrompt': 'این جلسه لغو شود؟ استودیو می‌تواند آن را لغو کند. دلیل (اختیاری)',
  'schedule.event': 'رویداد',
  'schedule.openEvents': 'باز کردن رویدادها',
  'schedule.attendance': 'حضور — {name}',
  'schedule.attendanceFailed': 'ثبت حضور ناموفق بود',
  'schedule.noEnrollments': 'ثبت‌نام فعالی نیست',
  'schedule.sessionsLeft': '{remaining} از {granted} جلسه باقی است',
  'schedule.leave': 'مرخصی',
  'schedule.taughtLabel': 'آنچه آموزش داده شد',
  'schedule.taughtHint': 'موضوعات را با ویرگول جدا کنید',
  'schedule.summary': 'خلاصه',
  'schedule.homework': 'تمرین خانگی',
  'schedule.saveTeaching': 'ذخیره یادداشت آموزش',

  'events.title': 'رویدادها',
  'events.subtitle': 'برگزاری‌های تک‌جلسه — سوشال، تمرین، ورکشاپ',
  'events.new': 'رویداد جدید',
  'events.loadFailed': 'بارگذاری رویدادها ناموفق بود',
  'events.registerFailed': 'ثبت‌نام ممکن نشد',
  'events.empty': 'هنوز رویدادی نیست',
  'events.emptyHint': 'سوشال‌ها و جلسات تمرین اینجا دیده می‌شوند.',
  'events.register': 'ثبت‌نام',
  'events.attendance': 'حضور',
  'events.cancel': 'لغو رویداد',
  'events.cancelPrompt': 'این رویداد تک‌جلسه لغو شود؟ دلیل را بنویسید (اختیاری).',
  'events.edit': 'ویرایش رویداد',
  'events.manage': 'مدیریت رویداد',
  'events.saveFailed': 'ذخیره رویداد ناموفق بود',
  'events.createFailed': 'ساخت رویداد ناموفق بود',
  'events.name': 'نام',
  'events.type': 'نوع',
  'events.location': 'مکان',
  'events.responsible': 'مسئول',
  'events.responsibleHint': 'اختیاری — مربی الزامی نیست. برای جستجو نام یا تلفن را بنویسید.',
  'events.responsibleNone': 'بدون مسئول',
  'events.clearResponsible': 'حذف مسئول',
  'events.description': 'توضیح',
  'events.duration': 'مدت (دقیقه)',
  'events.noRegs': 'هنوز ثبت‌نامی نیست',
  'events.studentFallback': 'هنرجو {id}',
  'events.covered': 'آنچه پوشش داده شد',
  'events.coveredHint': 'موضوعات را با ویرگول جدا کنید',
  'events.saveNotes': 'ذخیره یادداشت‌ها',

  'people.title': 'اشخاص',
  'people.subtitle': 'اطلاعات پایه هنرجویان، مربیان و کارکنان',
  'people.new': 'شخص جدید',
  'people.loadFailed': 'بارگذاری اشخاص ناموفق بود',
  'people.searchEmpty': 'نتیجه‌ای پیدا نشد',
  'people.restricted': 'محدود',
  'people.restrictedHint': 'فقط مدیر و مالک به فهرست اشخاص دسترسی دارند.',
  'people.search': 'جستجوی نام، تلفن یا ایمیل',
  'people.filterStatus': 'وضعیت',
  'people.filterAll': 'همه',
  'people.filterLevel': 'سطح',
  'people.filterEnrollment': 'ثبت‌نام کلاس',
  'people.filterEnrolled': 'دارای کلاس فعال',
  'people.filterUnenrolled': 'بدون کلاس فعال',
  'people.filterClass': 'کلاس',
  'people.filterAllClasses': 'همه کلاس‌ها',
  'people.resultsSummary': 'نمایش {from} تا {to} از {total} هنرجو',
  'people.pageOf': 'صفحه {page} از {total}',
  'people.prevPage': 'قبلی',
  'people.nextPage': 'بعدی',
  'people.noResults': 'نتیجه‌ای با این جستجو پیدا نشد',
  'people.empty': 'هنوز {role}ی ثبت نشده',
  'people.tabCoaches': 'مربی‌ها',
  'people.profile': 'پروفایل',
  'people.createFailed': 'ساخت شخص ممکن نشد',
  'people.name': 'نام',
  'people.email': 'ایمیل',
  'people.phone': 'تلفن',
  'people.tempPassword': 'رمز موقت',
  'people.contactVerified': 'تماس تأییدشده (بدون نیاز به تأیید ایمیل/موبایل)',
  'people.contactVerifiedHint': 'اگر این گزینه را بردارید، کاربر پس از ورود باید ایمیل یا موبایل را خودش تأیید کند.',
  'people.role': 'نقش',
  'people.status': 'وضعیت',
  'people.emergency': 'مخاطب اضطراری',
  'people.emergencyPhone': 'تلفن اضطراری',
  'people.level': 'سطح',
  'people.honorific': 'عنوان',
  'people.honorific.mr': 'آقا',
  'people.honorific.ms': 'خانم',
  'people.honorificChoose': 'آقا یا خانم را انتخاب کنید',
  'people.honorificHint': 'برای شکلک رقصنده مرد یا زن در داشبورد و کارت‌ها لازم است.',
  'profile.packIcon': 'نماد دوره جلسات',
  'profile.packIcon.dancer': 'رقصنده',
  'profile.packIcon.heart': 'قلب',
  'profile.packIconHint': 'این نماد در خانه‌های دوره جلسات نمایش داده می‌شود.',
  'profile.photo': 'تصویر پروفایل',
  'profile.photoHint': 'عکس تمام‌رخ از شانه به بالا، رو به دوربین. حداکثر ۱ مگابایت (فایل‌های بالای ۲۰۰ کیلوبایت خودکار فشرده می‌شوند).',
  'profile.photoChoose': 'انتخاب عکس',
  'profile.photoUploading': 'در حال بهینه‌سازی و بارگذاری تصویر…',
  'profile.photoFailed': 'بارگذاری تصویر ناموفق بود — فایل را کوچک‌تر کنید یا JPEG/PNG/WebP بفرستید.',
  'profile.photoTooLarge1MB': 'حجم تصویر نباید بیشتر از ۱ مگابایت باشد.',
  'profile.photoInvalidFormat': 'فرمت فایل نامعتبر است (فرمت‌های مجاز: JPG، PNG، WebP).',
  'profile.photoGuidance': 'راهنمای عکس پرسنلی',
  'people.bio': 'بیوگرافی',
  'people.specialties': 'تخصص‌ها',
  'people.specialtiesHint': 'با ویرگول جدا کنید',
  'people.notes': 'یادداشت‌ها',
  'people.delete': 'حذف حساب',
  'people.deleteConfirm': 'این حساب برای همیشه حذف می‌شود. ادامه می‌دهید؟',
  'people.deleteFailed': 'حذف حساب ممکن نشد',
  'people.demoteAdmin': 'برکناری از مدیر',
  'people.makeAdmin': 'انتصاب به‌عنوان مدیر',
  'people.roleSaved': 'نقش به‌روز شد',
  'people.cannotEditOwner': 'حساب مالک قابل ویرایش نیست',

  'profile.title': 'پروفایل من',
  'profile.subtitle': 'اطلاعات پایه برای پیامک، تماس اضطراری و سوابق کلاس',
  'profile.loadFailed': 'بارگذاری پروفایل ناموفق بود',
  'profile.address': 'نشانی',
  'profile.phoneHint': 'برای اطلاعیه‌های پیامکی لازم است',
  'profile.emailHint': 'اختیاری — برای ورود با ایمیل و دریافت رسید پرداخت‌ها',
  'profile.saveFailed': 'ذخیره ناموفق بود',
  'profile.saved': 'ذخیره شد.',
  'profile.save': 'ذخیره پروفایل',

  'notices.title': 'اطلاعیه‌ها',
  'notices.mineSubtitle': 'پیامک و ایمیل‌های ارسال‌شده برای شما',
  'notices.adminSubtitle': 'اعلام از طریق پیامک (SMS.ir) و ایمیل',
  'notices.loadFailed': 'بارگذاری اطلاعیه‌ها ناموفق بود',
  'notices.empty': 'هنوز اطلاعیه‌ای نیست',
  'notices.send': 'ارسال اطلاعیه',
  'notices.noticeTitle': 'عنوان',
  'notices.message': 'متن',
  'notices.audience': 'مخاطب',
  'notices.allStudents': 'همه هنرجویان',
  'notices.oneClass': 'یک کلاس',
  'notices.oneEvent': 'یک رویداد',
  'notices.selectClass': 'کلاس را انتخاب کنید',
  'notices.selectEvent': 'رویداد را انتخاب کنید',
  'notices.sms': 'پیامک',
  'notices.email': 'ایمیل',
  'notices.chooseChannel': 'پیامک یا ایمیل را انتخاب کنید',
  'notices.sendFailed': 'ارسال ناموفق بود',
  'notices.history': 'تاریخچه',
  'notices.audienceClass': 'کلاس',
  'notices.audienceEvent': 'رویداد',
  'notices.audienceAll': 'همه هنرجویان',
  'notices.banner': 'بنر بالای صفحه',
  'notices.bannerHint': 'یک پیام کوتاه برای نمایش در بالای برنامه، برای همه یا گروهی از کاربران.',
  'notices.bannerMessage': 'پیام یک‌خطی',
  'notices.bannerSave': 'فعال‌سازی بنر',
  'notices.bannerSaved': 'بنر فعال شد',
  'notices.bannerActive': 'بنرهای فعال',
  'notices.bannerEmpty': 'بنر فعالی نیست',
  'notices.bannerDeactivate': 'خاموش کردن',
  'notices.bannerExpires': 'انقضا (اختیاری)',
  'notices.audienceAllUsers': 'همه کاربران',
  'notices.audienceCoaches': 'مربیان',
  'notices.audienceOperators': 'پرسنل',
  'notices.audienceClassStudents': 'هنرجویان یک کلاس',
  'notices.audienceAuth': 'صفحات ورود و احراز هویت (عمومی)',
  'banner.dismiss': 'بستن بنر',
  'banner.label': 'اعلام مدیریت',

  'timeline.empty': 'هنوز جلسه‌ای نیست',
  'timeline.emptyHint': 'حضور و آنچه یاد گرفته‌اید اینجا دیده می‌شود.',
  'timeline.coach': 'مربی: {name}',
  'timeline.substitute': '(جایگزین)',
  'timeline.learned': 'آموخته‌ها: {topics}',
  'timeline.homework': 'تمرین: {text}',
  'timeline.files': 'فایل‌ها: {names}',

  'billing.loadFailed': 'بارگذاری مالی ناموفق بود',
  'billing.institute': 'محاسبات مالی',
  'billing.instituteHint': 'کلاس‌ها بر اساس حضور محاسبه‌شونده هر ثبت‌نام است. حقوق مربی بر اساس تدریس و مدت. مبالغ به تومان.',
  'billing.income': 'درآمد',
  'billing.tuition': 'شهریه {amount}',
  'billing.vending': 'فروش {amount}',
  'billing.expenses': 'هزینه‌ها',
  'billing.coaches': 'مربیان {amount}',
  'billing.other': 'سایر {amount}',
  'billing.net': 'خالص',
  'billing.studentDue': '{amount} بدهی هنرجو',
  'billing.tabClasses': 'کلاس‌ها',
  'billing.tabStudents': 'هنرجویان',
  'billing.tabPayments': 'پرداخت‌ها',
  'billing.tabCoaches': 'حقوق مربی و پرسنل',
  'billing.tabCashbook': 'صندوق',
  'billing.tabSettings': 'تنظیمات',
  'billing.class': 'کلاس',
  'billing.pack': 'دوره',
  'billing.studentIn': 'ورودی هنرجو',
  'billing.openDue': 'بدهی باز',
  'billing.coachCost': 'هزینه مربی',
  'billing.studentHint': 'جلسات باقی‌مانده متعلق به ثبت‌نام است. مرخصی مصرف نمی‌شود. سررسید پس از حضور محاسبه‌شونده است.',
  'billing.student': 'هنرجو',
  'billing.used': 'مصرف‌شده',
  'billing.remaining': 'باقی‌مانده',
  'billing.noInvoices': 'فاکتور باز هنرجو نیست.',
  'billing.exportExcel': 'دانلود گزارش اکسل (Excel)',
  'billing.exportOwnerOnly': 'خروجی اکسل فقط ویژه مدیر آموزشگاه است',
  'billing.searchStudentPlaceholder': 'جستجو بر اساس نام، موبایل، ایمیل یا شماره فاکتور...',
  'billing.filterClass': 'فیلتر کلاس',
  'billing.filterStatus': 'فیلتر وضعیت مالی',
  'billing.filterAllClasses': 'همه کلاس‌ها',
  'billing.filterStatusAll': 'همه وضعیت‌های مالی',
  'billing.filterStatusSettled': 'تسویه کامل (بدون بدهی)',
  'billing.filterStatusDue': 'دارای بدهی / در انتظار پرداخت',
  'billing.filterStatusOverdue': 'دارای معوقه (سررسید گذشته)',
  'billing.filterStatusDiscounted': 'دارای تخفیف',
  'billing.dateFrom': 'از تاریخ',
  'billing.dateTo': 'تا تاریخ',
  'billing.filterDateRange': 'بازه زمانی شمسی',
  'billing.clearDateFilter': 'حذف فیلتر تاریخ',
  'billing.viewGrouped': 'نمای هنرجویان',
  'billing.viewInvoices': 'ریز فاکتورها',
  'billing.totalTuition': 'شهریه کل',
  'billing.totalPaidAmount': 'کل دریافتی',
  'billing.totalDiscountAmount': 'کل تخفیف‌ها',
  'billing.totalOpenDueAmount': 'کل بدهی باز',
  'billing.financialStatus': 'وضعیت مالی',
  'billing.statusSettled': 'تسویه کامل',
  'billing.statusHasDue': 'دارای بدهی',
  'billing.statusOverdue': 'سررسید گذشته',
  'billing.statusNoInvoices': 'بدون فاکتور',
  'billing.sessionsProgress': 'جلسات (مصرف/کل)',
  'billing.invoicesBreakdown': 'ریز فاکتورها',
  'billing.hideBreakdown': 'بستن',
  'billing.discountGiven': 'تخفیف: {amount}',
  'billing.resetFilters': 'پاک کردن فیلترها',
  'billing.noStudentsFound': 'هنرجویی با فیلترهای انتخابی یافت نشد.',
  'billing.invoiceNum': 'شماره فاکتور',
  'billing.originalPrice': 'مبلغ پایه',
  'billing.payablePrice': 'مبلغ پرداختی',
  'billing.paidDate': 'تاریخ پرداخت',
  'billing.dueDate': 'سررسید',
  'billing.enrollmentPack': 'دوره ثبت‌نام',
  'billing.topupPack': 'دوره تمدید',
  'billing.sessionsDue': '{n} جلسه · سررسید {date}',
  'billing.cash': 'نقد',
  'billing.bank': 'بانک',
  'billing.manual': 'دستی',
  'billing.recordPaid': 'ثبت پرداخت',
  'billing.sessions': 'جلسات',
  'billing.hours': 'ساعت',
  'billing.amount': 'مبلغ',
  'billing.hourlyAgreement': 'توافق پرداخت',
  'billing.hourlyRate': 'مبلغ (تومان)',
  'billing.saveAgreement': 'ذخیره توافق',
  'billing.updateAgreement': 'به‌روزرسانی توافق',
  'billing.staffCompensation': 'نحوه پرداخت',
  'billing.current': 'فعلی: {list}',
  'billing.perHour': '{name} {amount}/ساعت',
  'billing.staffPay': 'نحوه پرداخت مربی و پرسنل',
  'billing.staff': 'فرد',
  'billing.payType': 'نوع پرداخت',
  'billing.payType.fixed': 'مبلغ تومان',
  'billing.payType.percentage': 'درصدی',
  'billing.percentage': 'درصد',
  'billing.fixedToman': 'مبلغ تومان',
  'billing.perPercent': '{name} {n}٪',
  'billing.flatAmount': '{name} {amount}',
  'billing.payHint.fixedCoach': 'مبلغ ساعتی به تومان برای هر جلسه تدریس‌شده.',
  'billing.payHint.fixedOperator': 'مبلغ ثابت تومان برای دوره جاری.',
  'billing.payHint.percentageCoach': 'درصد از شهریه کلاس‌هایی که این مربی تدریس کرده.',
  'billing.payHint.percentageOperator': 'درصد از فروش صندوق / وندینگ.',
  'billing.defaultPack': 'دوره پیش‌فرض هنرجو',
  'billing.sessionsPerPack': 'جلسه در هر دوره',
  'billing.priceToman': 'قیمت (تومان)',
  'billing.updateDefault': 'به‌روزرسانی پیش‌فرض',
  'billing.overduePolicy': 'سیاست سررسید گذشته',
  'billing.whenOverdue': 'وقتی فاکتور سررسید گذشته است',
  'billing.notifyOnly': 'فقط اطلاع',
  'billing.blockAttendance': 'مسدود کردن حضور',
  'billing.blockEnrollment': 'مسدود کردن ثبت‌نام جدید',
  'billing.savePolicy': 'ذخیره سیاست',

  'cashbook.title': 'صندوق',
  'cashbook.subtitle': 'هر ردیف به‌صورت درآمد یا هزینه با دلیل ذخیره می‌شود. پرداخت شهریه یک رکورد پرداخت و لاگ هم می‌سازد.',
  'cashbook.record': 'ثبت',
  'cashbook.history': 'تاریخچه',
  'cashbook.type': 'نوع',
  'cashbook.reason': 'دلیل',
  'cashbook.period': 'دوره',
  'cashbook.periodStart': 'تاریخ دوره',
  'cashbook.amount': 'مبلغ (تومان)',
  'cashbook.note': 'یادداشت',
  'cashbook.save': 'ذخیره ردیف',
  'cashbook.empty': 'هنوز ردیفی در صندوق نیست.',
  'cashbook.income': 'درآمد',
  'cashbook.expense': 'هزینه',
  'cashbook.studentTuition': 'شهریه هنرجو',
  'cashbook.eventFee': 'هزینه رویداد',
  'cashbook.vending': 'فروش',
  'cashbook.coachPay': 'حقوق مربی',
  'cashbook.supplies': 'لوازم',
  'cashbook.rent': 'اجاره',
  'cashbook.other': 'سایر',
  'cashbook.daily': 'روزانه',
  'cashbook.weekly': 'هفتگی',
  'cashbook.adhoc': 'موردی',

  'studentBilling.title': 'مالی شما',
  'studentBilling.subtitle': 'پرداخت بر اساس حضور محاسبه‌شونده در هر کلاس است — مرخصی تأییدشده حساب نمی‌شود.',
  'studentBilling.amountDue': 'مبلغ بدهی',
  'studentBilling.openInvoices': '{n} فاکتور باز',
  'studentBilling.typicalPack': 'دوره معمول',
  'studentBilling.chargeableSessions': '{n} جلسه محاسبه‌شونده',
  'studentBilling.soonest': 'نزدیک‌ترین پرداخت',
  'studentBilling.soonestMeta': 'جلسه باقی‌مانده در نزدیک‌ترین دوره',
  'studentBilling.packs': 'کلاس‌ها',
  'studentBilling.invoices': 'فاکتورها',
  'studentBilling.noEnrollments': 'ثبت‌نام فعالی نیست.',
  'studentBilling.progress': '{consumed} از {granted} جلسه محاسبه‌شده · {remaining} تا سررسید بعدی.',
  'studentBilling.noInvoices': 'هنوز فاکتوری نیست.',
  'studentBilling.packMeta': '{kind} · {n} جلسه · سررسید {date}',
  'studentBilling.paidOn': 'پرداخت‌شده {date}',

  'coachBilling.title': 'حقوق شما',
  'coachBilling.subtitle': 'حقوق از جلساتی که واقعاً تدریس کرده‌اید — از جمله جایگزینی — با توافق ساعتی محاسبه می‌شود.',
  'coachBilling.thisPeriod': 'این دوره',
  'coachBilling.hoursDelivered': 'ساعت تدریس‌شده',
  'coachBilling.sessions': 'جلسات',
  'coachBilling.summary': 'خلاصه',
  'coachBilling.hint': 'نرخ شما روی مربی حاضر و مدت جلسه اعمال می‌شود. ساعت جایگزینی مال شماست اگر خودتان تدریس کرده باشید.',
  'coachBilling.hoursAcross': '{hours} ساعت در {sessions} جلسه',
  'coachBilling.noSessions': 'در این دوره جلسه‌ای تدریس نشده.',
  'coachBilling.lineMeta': '{date} · {minutes} دقیقه · {rate}/ساعت',
  'coachBilling.replacement': 'جایگزین',

  'leave.title': 'مرخصی من',
  'leave.studentSubtitle': 'با اطلاع قبلی درخواست دهید. پس از تأیید مدیر، برای جلسات آن بازه مرخصی ثبت می‌شود و جلسه از دوره کم نمی‌شود.',
  'leave.adminTitle': 'درخواست‌های مرخصی',
  'leave.adminSubtitle': 'تأیید یا رد درخواست‌ها — مرخصی تأییدشده به‌صورت سیستمی روی جلسات اعمال می‌شود.',
  'leave.restricted': 'این بخش برای نقش شما در دسترس نیست.',
  'leave.minNotice': 'حداقل اطلاع',
  'leave.noticeDefault': 'پیش‌فرض: ۱۴ روز قبل از شروع مرخصی',
  'leave.maxDuration': 'حداکثر مدت هر درخواست',
  'leave.season': 'سهمیه فصل',
  'leave.seasonMonths': 'طول فصل (ماه)',
  'leave.seasonDays': 'سقف تعداد درخواست در هر فصل',
  'leave.seasonHint': 'هر {months} ماه حداکثر {n} بار درخواست مرخصی',
  'leave.seasonUsed': '{used} از {limit} درخواست در این فصل',
  'leave.seasonBad': 'سهمیه فصل کافی نیست — {remaining} درخواست باقی مانده.',
  'leave.durationBad': 'مدت مرخصی نمی‌تواند بیشتر از {n} روز باشد.',
  'leave.settingsTitle': 'سیاست مرخصی آموزشگاه',
  'leave.settingsSubtitle': 'هنرجو از پنل خودش درخواست می‌دهد؛ مدیر تأیید یا رد می‌کند. حداقل اطلاع پیش‌فرض ۱۴ روز است و سقف تعداد درخواست در هر فصل سه‌ماهه قابل تنظیم است.',
  'leave.settingsSaved': 'سیاست مرخصی ذخیره شد.',
  'leave.settingsFailed': 'ذخیره سیاست مرخصی ناموفق بود',
  'leave.sessionBehavior': 'رفتار جلسه',
  'leave.packBehavior': 'دوره جلسات',
  'leave.days': '{n} روز',
  'leave.approvedOnly': 'فقط با تأیید',
  'leave.noConsume': 'مصرف نمی‌شود',
  'leave.request': 'درخواست مرخصی',
  'leave.class': 'کلاس',
  'leave.start': 'شروع مرخصی',
  'leave.end': 'پایان مرخصی',
  'leave.note': 'یادداشت (اختیاری)',
  'leave.submit': 'ارسال درخواست',
  'leave.requestFailed': 'ثبت درخواست مرخصی ناموفق بود',
  'leave.noticeOk': 'اطلاع‌رسانی کافی است ({n} روز).',
  'leave.noticeBad': 'فقط {n} روز مانده — حداقل {min} روز لازم است.',
  'leave.noticeMeta': '{n} روز اطلاع · حداقل {min}',
  'leave.empty': 'درخواستی نیست.',
  'leave.approve': 'تأیید',
  'leave.deny': 'رد',
  'leave.filter.pending': 'در انتظار',
  'leave.filter.approved': 'تأیید شده',
  'leave.filter.denied': 'رد شده',
  'leave.filter.all': 'همه',
  'leave.needsApproval': 'مرخصی فقط با درخواست تأییدشده',
  'leave.sessionConsumed': 'یک جلسه از دوره مصرف شد',
  'leave.sessionConsumedAbsent': 'غایب — یک جلسه از دوره مصرف شد',
  'leave.sessionFrozen': 'مرخصی تأییدشده — جلسه کم نمی‌شود',

  'enroll.stepStudent': 'هنرجو و دوره',
  'enroll.stepPolicy': 'سیاست مرخصی',
  'enroll.stepConfirm': 'تأیید',
  'enroll.selectClass': 'انتخاب کلاس',
  'enroll.confirmTitle': 'تأیید ثبت‌نام',
  'enroll.policyHint': 'پیش‌فرض‌ها از سطح آموزشگاه می‌آیند؛ برای این ثبت‌نام می‌توانید آن‌ها را تغییر دهید. پس از تأیید مرخصی، جلسه کم نمی‌شود.',
  'enroll.policyConfigurable': 'قابل تنظیم',
  'enroll.policyDaysUnit': 'روز',
  'enroll.packSummary': 'دوره {n} جلسه‌ای برای این کلاس',
  'enroll.invoiceHint': 'حاضر یا غایب یک جلسه مصرف می‌کند. پس از {n} جلسه مصرف‌شده، فاکتور صادر می‌شود.',
  'enroll.back': 'قبلی',
  'enroll.next': 'بعدی',

  'enrollments.title': 'ثبت‌نام‌ها',
  'enrollments.subtitle': 'ثبت‌نام هنرجو در کلاس، وضعیت دوره جلسات و سیاست مرخصی.',
  'enrollments.create': 'ایجاد ثبت‌نام',
  'enrollments.empty': 'ثبت‌نامی یافت نشد.',
  'enrollments.loadFailed': 'بارگذاری ثبت‌نام‌ها ناموفق بود',
  'enrollments.enrolledAt': 'از {date}',
  'enrollments.cycle': 'چرخه دوره',
  'enrollments.filter.all': 'همه',
  'enrollments.filter.active': 'فعال',
  'enrollments.filter.pending': 'در انتظار',
  'enrollments.filter.paused': 'متوقف',
  'enrollments.filter.billing': 'بدهکار',

  'dash.day.sat': 'شنبه',
  'dash.day.sun': 'یکشنبه',
  'dash.day.mon': 'دوشنبه',
  'dash.day.tue': 'سه‌شنبه',
  'dash.day.wed': 'چهارشنبه',
  'dash.day.thu': 'پنجشنبه',
  'dash.day.fri': 'جمعه',
  'dash.heroMeta': '{classes} کلاس فعال · {students} هنرجو · {coaches} مربی در برنامه',
  'dash.chip.consumed': 'جلسات مصرف‌شده',
  'dash.kpi.enrolled': 'ثبت‌نام‌شده',
  'dash.kpi.enrolledSub': 'هنرجویان فعال',
  'dash.kpi.classes': 'کلاس‌های فعال',
  'dash.kpi.classesSub': 'در {n} رشته',
  'dash.kpi.sessionsDue': 'جلسات مصرف‌شده',
  'dash.kpi.sessionsDueSub': 'چرخه جاری',
  'dash.kpi.invoices': 'فاکتورهای باز',
  'dash.kpi.invoicesSub': '{n} هنرجو بدهکار',
  'dash.sessions': 'جلسات',
  'dash.enrollments': 'ثبت‌نام‌های فعال',
  'dash.enrollmentCount': '{n} هنرجو',
  'dash.enrollmentsEmpty': 'ثبت‌نام فعالی نیست.',

  'student.leaveCta': 'درخواست مرخصی',
  'student.leaveHint': 'اگر نمی‌توانید در کلاس حاضر شوید، از اینجا مرخصی بخواهید تا پس از تأیید جلسه کم نشود.',

  'billing.funnelTitle': 'چرخه دوره جلسات',
  'billing.funnel.1.title': 'حضور یا غیاب',
  'billing.funnel.1.desc': 'یک جلسه از دوره کم می‌شود',
  'billing.funnel.2.title': 'آستانه دوره',
  'billing.funnel.2.desc': 'مصرف کامل → رویداد فاکتور',
  'billing.funnel.3.title': 'صدور فاکتور',
  'billing.funnel.3.desc': 'صورتحساب هنرجو ساخته می‌شود',
  'billing.funnel.4.title': 'پرداخت و تمدید',
  'billing.funnel.4.desc': 'دوره تازه برای ادامه کلاس',

  'attendancePage.adminTitle': 'دفتر حضور و غیاب',
  'attendancePage.adminSubtitle': 'حاضر یا غایب یک جلسه از دوره کم می‌کند. هنرجویان با مرخصی تأییدشده قفل‌اند و جلسه کم نمی‌شود.',
  'attendancePage.coachTitle': 'سوابق حضور کلاس‌های من',
  'attendancePage.coachSubtitle': 'هنرجویانی که در جلسات شما ثبت شده‌اند. برای تغییر وضعیت، وارد جلسه شوید.',
  'attendancePage.restricted': 'این بخش برای نقش شما در دسترس نیست.',
  'attendancePage.loadFailed': 'بارگذاری حضور ناموفق بود',
  'attendancePage.empty': 'هنوز رکوردی ثبت نشده.',
  'attendancePage.frozen': 'مرخصی',
  'attendancePage.sessionConsumed': '−۱ جلسه',
  'attendancePage.noConsume': 'بدون کسر',
  'attendancePage.legendPresent': 'حاضر — جلسه کسر می‌شود',
  'attendancePage.legendAbsent': 'غایب — جلسه کسر می‌شود',
  'attendancePage.legendFrozen': 'مرخصی تأییدشده — بدون کسر',
  'cal.selectSession': 'یک جلسه را انتخاب کنید',
  'cal.classesToday': '{n} کلاس امروز',
  'cal.openAttendance': 'دفتر حضور',
  'cal.enrollStudent': 'ثبت‌نام هنرجو',

  'activity.title': 'خط زمانی فعالیت‌ها',
  'activity.subtitle': 'ثبت‌نام، فاکتور، مرخصی و رویدادهای پیشِ‌رو در یک نگاه.',
  'activity.loadFailed': 'بارگذاری فعالیت‌ها ناموفق بود',
  'activity.enrollment': 'ثبت‌نام',
  'activity.invoicePaid': 'فاکتور پرداخت‌شده',
  'activity.invoiceSent': 'فاکتور ارسال‌شده',
  'activity.invoiceOverdue': 'فاکتور سررسید گذشته',
  'activity.leaveDenied': 'مرخصی رد شده',
  'activity.leaveApproved': 'مرخصی تأیید شده',
  'activity.leaveStarts': 'شروع مرخصی',
  'activity.today': 'امروز',
  'activity.filter.all': 'همه رویدادها',
  'activity.filter.enrollment': 'ثبت‌نام',
  'activity.filter.payment': 'پرداخت',
  'activity.filter.invoice': 'فاکتور',
  'activity.filter.leave': 'مرخصی',

  'settings.tabDiscounts': 'تخفیف‌ها',
  'settings.registrationTitle': 'وضعیت ثبت‌نام عمومی',
  'settings.registrationSubtitle': 'مدیریت امکان ثبت‌نام کاربران جدید در سامانه',
  'settings.registrationOpen': 'ثبت‌نام عمومی باز است',
  'settings.registrationClosed': 'ثبت‌نام عمومی بسته است',
  'settings.registrationOpenDesc': 'کاربران جدید می‌توانند به صورت مستقیم از صفحه ثبت‌نام در سامانه ثبت‌نام کنند.',
  'settings.registrationClosedDesc': 'ثبت‌نام برای کاربران جدید بسته است. تنها مالک و مدیر می‌توانند از منوی اشخاص کاربر جدید اضافه کنند. کاربران موجود می‌توانند وارد حساب خود شوند.',
  'settings.registrationToggleOpen': 'باز کردن ثبت‌نام عمومی',
  'settings.registrationToggleClose': 'بستن ثبت‌نام عمومی',
  'settings.registrationSaved': 'وضعیت ثبت‌نام به‌روزرسانی شد.',
  'settings.registrationSaveFailed': 'خطا در تغییر وضعیت ثبت‌نام.',

  'discounts.title': 'مدیریت تخفیف‌های ثبت‌نام',
  'discounts.subtitle': 'تعریف و مدیریت تخفیف‌های ثبت‌نام برای کلاس‌ها و رویدادها ویژه هنرجویان قبلی، نقش‌ها یا افراد مشخص',
  'discounts.empty': 'هنوز هیچ تخفیفی تعریف نشده است.',
  'discounts.new': 'افزودن تخفیف جدید',
  'discounts.edit': 'ویرایش تخفیف',
  'discounts.delete': 'حذف تخفیف',
  'discounts.deleteConfirm': 'آیا از حذف این تخفیف اطمینان دارید؟',
  'discounts.name': 'عنوان تخفیف',
  'discounts.namePlaceholder': 'مثلاً: تخفیف هنرجویان قبلی یا تخفیف مربیان',
  'discounts.targetType': 'هدف تخفیف',
  'discounts.targetClass': 'کلاس',
  'discounts.targetEvent': 'رویداد',
  'discounts.classSelect': 'انتخاب کلاس',
  'discounts.eventSelect': 'انتخاب رویداد',
  'discounts.appliesTo': 'مشمول تخفیف',
  'discounts.appliesOlderStudents': 'هنرجویان قبلی این کلاس (هنرجوی قدیمی)',
  'discounts.appliesOlderStudentsHint': 'فقط به هنرجویانی که سابقه ثبت‌نام قبلی در همین کلاس دارند تعلق می‌گیرد.',
  'discounts.appliesSpecificStudent': 'هنرجوی مشخص',
  'discounts.appliesRole': 'بر اساس نقش کاربری',
  'discounts.appliesAll': 'همه افراد',
  'discounts.studentSelect': 'انتخاب هنرجو',
  'discounts.roleSelect': 'انتخاب نقش',
  'discounts.discountType': 'نوع تخفیف',
  'discounts.typePercentage': 'درصدی (٪)',
  'discounts.typeFixed': 'مبلغ ثابت (تومان)',
  'discounts.value': 'مقدار تخفیف',
  'discounts.active': 'تخفیف فعال است',
  'discounts.saveSuccess': 'تخفیف با موفقیت ذخیره شد.',
  'discounts.saveFailed': 'خطا در ذخیره تخفیف.',
  'discounts.deleteSuccess': 'تخفیف با موفقیت حذف شد.',
  'discounts.filterAll': 'همه اهداف',
  'discounts.filterClass': 'تخفیف‌های کلاس',
  'discounts.filterEvent': 'تخفیف‌های رویداد',
  'discounts.appliedDiscount': 'تخفیف اعمال‌شده: {amount}',
  'discounts.originalPrice': 'قیمت اصلی: {price}',
  'discounts.finalPrice': 'قیمت پس از تخفیف: {price}',
  'discounts.selectDiscount': 'نوع تخفیف ثبت‌نام',
  'discounts.autoDiscount': 'تخفیف خودکار شناسایی‌شده',
  'discounts.noDiscount': 'بدون تخفیف',
  'discounts.customDiscount': 'تخفیف دستی دلخواه',
  'discounts.customAmount': 'مبلغ تخفیف دستی (تومان)',
  'discounts.customReason': 'علت تخفیف دستی',
  'discounts.olderStudentBadge': 'هنرجوی قبلی کلاس',

  'auth.registrationClosedTitle': 'ثبت‌نام عمومی در حال حاضر بسته است',
  'auth.registrationClosedMessage': 'امکان ایجاد حساب کاربری برای کاربران جدید غیرفعال است. در صورتی که قبلاً حساب کاربری داشته‌اید، می‌توانید وارد شوید. برای ثبت‌نام جدید با مدیریت آموزشگاه تماس حاصل نمایید.',
  'auth.registrationClosedGoToSignIn': 'ورود به حساب کاربری',
  'auth.registrationClosedContactTelegram': 'ارتباط با مدیریت در تلگرام',
  'auth.registrationClosedGoogle': 'ثبت‌نام برای کاربران جدید بسته است. ورود با گوگل فقط برای حساب‌های کاربری از پیش ثبت‌شده مجاز است.',

  'events.price': 'هزینه ورودی (تومان)',
  'events.free': 'رایگان',
  'events.priceHint': 'اختیاری — برای رویدادهای رایگان ۰ بگذارید',

  'pwa.install.title': 'نصب اپ دنس‌منس',
  'pwa.install.ios': 'برای نصب، دکمه اشتراک‌گذاری را بزنید و «افزودن به صفحه اصلی» را انتخاب کنید.',
  'pwa.install.android': 'این اپ را روی گوشی نصب کنید — سریع‌تر، بدون مرورگر!',
  'pwa.install.cta': 'نصب اپ',
  'pwa.install.dismiss': 'بستن',
} as const;

export type MessageKey = keyof typeof fa;
